import produce from 'immer';
import { CLOSE_SNACKBAR_NOTIFICATION, SHOW_NOTIFICATION } from '../actions/ui';
import {
  GET_STORE_PRODUCTS_FAILED,
  GET_CATEGORY_PRODUCTS_FAILED,
  EDIT_SUBSCRIPTION_OPTION_FAILED,
  DELETE_SUBSCRIPTION_OPTION_FAILED,
  DELETE_CUSTOM_OPTION_FAILED,
  DELETE_CUSTOM_OPTION_SUCCESS,
  DELETE_CUSTOM_OPTION_VALUE_FAILED,
  DELETE_CUSTOM_OPTION_VALUE_SUCCESS,
  EDIT_CUSTOM_OPTION_FAILED,
  EDIT_CUSTOM_OPTION_SUCCESS,
  ADD_CUSTOM_OPTION_FAILED,
  ADD_CUSTOM_OPTION_SUCCESS,
  ADD_PRODUCT_TO_STORE_SUCCESS,
  ADD_PRODUCT_TO_STORE_FAILED,
  MASS_ADD_PRODUCT_TO_STORE_SUCCESS,
  MASS_ADD_PRODUCT_TO_STORE_WARNING,
  MASS_ADD_PRODUCT_TO_STORE_FAILED,
  SAVE_CATEGORY_PRODUCTS_SUCCESS,
  EDIT_STORE_PRODUCT_SUCCESS,
  DELETE_STORE_PRODUCT_SUCCESS,
  DELETE_STORE_PRODUCT_FAILED,
  ADD_SUBSCRIPTION_OPTION_SUCCESS,
  EDIT_SUBSCRIPTION_OPTION_SUCCESS,
  DELETE_SUBSCRIPTION_OPTION,
  REMOVE_FBT_LINK_SUCCESS,
  REMOVE_FBT_LINK_FAILED,
  SAVE_FBT_LINKS_SUCCESS,
  SAVE_FBT_LINKS_WARNING,
  SAVE_FBT_LINKS_FAILED,
  SAVE_CUSTOM_OPTIONS_PRICE_TYPES_SUCCESS,
  SAVE_CUSTOM_OPTIONS_PRICE_TYPES_FAILED,
  SEND_DIRECT_FULFILLMENT_REQUEST_SUCCESS,
  SEND_DIRECT_FULFILLMENT_REQUEST_FAILED,
  EDIT_STORE_PRODUCT_UPSELL_SUCCESS,
  EDIT_STORE_PRODUCT_UPSELL_FAILED,
  REMOVE_STORE_PRODUCT_RELATED_LINKS_SUCCESS,
  REMOVE_STORE_PRODUCT_RELATED_LINKS_FAILED,
  EDIT_STORE_PRODUCT_CROSS_SELL_SUCCESS,
  EDIT_STORE_PRODUCT_CROSS_SELL_FAILED,
  SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_SUCCESS,
  SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_FAILED,
  SAVE_STORE_PRODUCT_MEDIA_GALLERY_SUCCESS,
  SAVE_STORE_PRODUCT_MEDIA_GALLERY_FAILED,
  RECEIVE_QUEUED_TASK_UPDATE,
  REMOVE_TASK_FROM_QUEUE_FAILED,
  ADD_SUBSCRIPTION_OPTION_FAILED
} from '../actions/products';
import {
  SAVE_STORE_EARNING_RULES_FAILED,
  SAVE_STORE_SPENDING_RULES_FAILED,
  SAVE_STORE_REWARD_BEHAVIOUR_RULES_FAILED
} from '../actions/marketing_rules';
import {
  GET_REWARD_BEHAVIOR_RULES_FAILED,
  UPDATE_REWARD_BEHAVIOR_RULE_SUCCESS,
  UPDATE_REWARD_BEHAVIOR_RULE_FAILED,
  UPDATE_STORE_CONFIGS_SUCCESS,
  UPDATE_STORE_SITE_MAP_FAILED,
  GET_SOCIAL_MEDIA_CONFIGS_FAILED,
  SAVE_SOCIAL_MEDIA_CONFIGS_SUCCESS,
  SAVE_SOCIAL_MEDIA_CONFIGS_FAILED,
  SAVE_NOTIFICATION_OPTIONS_SUCCESS,
  SAVE_NOTIFICATION_OPTIONS_WARNING,
  SAVE_NOTIFICATION_OPTIONS_FAILED,
  SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_FAILED,
  SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_FAILED,
  SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_FAILED,
  SAVE_ABOUT_US_PAGE_CONFIGS_SUCCESS,
  SAVE_ABOUT_US_PAGE_CONFIGS_FAILED,
  SAVE_STORE_CONTACTS_CONFIGS_FAILED,
  SAVE_STORE_NAME_FAILED,
  SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_FAILED,
  GET_APPOINTMENT_FORM_CONFIGS_FAILED,
  SAVE_APPOINTMENT_FORM_CONFIGS_SUCCESS,
  SAVE_APPOINTMENT_FORM_CONFIGS_FAILED,
  SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_FAILED,
  SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_FAILED,
  SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_FAILED,
  SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_FAILED,
  SAVE_STORE_EMAILS_CONFIGS_DATA_SUCCESS,
  SAVE_STORE_EMAILS_CONFIGS_DATA_FAILED
} from '../actions/store_configs';

import {
  UPDATE_STORE_EMAILS_DATA_SUCCESS,
  UPDATE_STORE_EMAILS_DATA_FAILED
} from '../actions/store_emails';

import {
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILED,
  DELETE_USER_STORE_SUCCESS,
  DELETE_USER_STORE_FAILED,
  DELETE_STORE_SUCCESS,
  DELETE_STORE_FAILED,
  ADD_STORE_SUCCESS,
  ADD_STORE_FAILED,
  ADD_USER_STORE_SUCCESS,
  ADD_USER_STORE_FAILED,
  SAVE_EDITED_STORE_FAILED,
  SAVE_EDITED_STORE_SUCCESS,
  CREATE_PERMISSION_CONFIG_SUCCESS,
  CREATE_PERMISSION_CONFIG_FAILED,
  UPDATE_PERMISSION_CONFIG_SUCCESS,
  UPDATE_PERMISSION_CONFIG_FAILED,
  DELETE_PERMISSION_CONFIG_SUCCESS,
  DELETE_PERMISSION_CONFIG_FAILED,
  CREATE_SM_USER_SUCCESS,
  CREATE_SM_USER_FAILED,
  CREATE_SUBSCRIPTION_COUPON_CODE_SUCCESS,
  CREATE_SUBSCRIPTION_COUPON_CODE_FAILED,
  UPDATE_SUBSCRIPTION_COUPON_CODE_SUCCESS,
  UPDATE_SUBSCRIPTION_COUPON_CODE_FAILED,
  DELETE_SUBSCRIPTION_COUPON_CODE_SUCCESS,
  DELETE_SUBSCRIPTION_COUPON_CODE_FAILED
} from '../actions/admin';
import {
  SAVE_STORE_CATEGORY_SUCCESS,
  SAVE_STORE_CATEGORY_FAILED
} from '../actions/categories';

import {
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_FAILED,
  SAVE_REQUEST_SKU_EMAIL_DATA_SUCCESS,
  SAVE_REQUEST_SKU_EMAIL_DATA_FAILED,
  SAVE_REQUEST_PROMOTION_EMAIL_DATA_SUCCESS,
  SAVE_REQUEST_PROMOTION_EMAIL_DATA_FAILED,
  REMOVE_UPLOADED_IMAGE,
  SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_SUCCESS,
  SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_FAILED
} from '../actions/email';

import {
  GET_FRAUD_ORDERS_FAILED,
  UPDATE_FRAUD_ORDER_STATUS_SUCCESS,
  UPDATE_FRAUD_ORDER_STATUS_FAILED
} from '../actions/sales';

import {
  ADD_STORE_PICKUP_LOCATION_SUCCESS,
  ADD_STORE_PICKUP_LOCATION_FAILED,
  UPDATE_STORE_PICKUP_LOCATION_SUCCESS,
  UPDATE_STORE_PICKUP_LOCATION_FAILED,
  DELETE_STORE_PICKUP_LOCATION_SUCCESS,
  DELETE_STORE_PICKUP_LOCATION_FAILED,
  UPDATE_STORE_PICKUP_CONFIG_SUCCESS,
  UPDATE_STORE_PICKUP_CONFIG_FAILED
} from '../actions/store_pickup';

import {
  GENERATE_COUPON_FOR_EMAIL_SUCCESS,
  GENERATE_COUPON_FOR_EMAIL_FAILED,
  GENERATE_COUPON_RULE_SUCCESS,
  GENERATE_COUPON_RULE_FAILED,
  UPDATE_COUPON_RULE_COMBINED_SUCCESS,
  UPDATE_COUPON_RULE_COMBINED_FAILED,
  CREATE_COUPON_RULE_COMBINED_SUCCESS,
  CREATE_COUPON_RULE_COMBINED_FAILED,
  DELETE_COUPON_RULE_SUCCESS,
  DELETE_COUPON_RULE_FAILED
} from '../actions/coupon_rules';

import {
  UPDATE_CMS_PAGE_SUCCESS,
  UPDATE_CMS_PAGE_FAILED
} from '../actions/cms_pages';

import {
  CREATE_PROMO_BY_TEMPLATE_SUCCESS,
  CREATE_PROMO_BY_TEMPLATE_FAILED,
  CANCEL_PROMOTION_FAILED,
  RESCHEDULE_PROMOTION_FAILED,
  RESCHEDULE_PROMOTION_SUCCESS,
  CANCEL_PROMOTION_SUCCESS
} from '../actions/promo';

import {
  DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_SUCCESS,
  DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_FAILED,
  DELETE_SINGLE_TEMPLATE_SUCCESS,
  DELETE_SINGLE_TEMPLATE_FAILED
} from '../actions/library';

import {
  UPLOAD_STORE_LOGOS_FAILED,
  UPLOAD_STORE_LOGOS_SUCCESS,
  UPDATE_ALL_LOGOS_FAILED,
  UPLOAD_STORE_LOGOS_TYPE_FAILED,
  UPDATE_ALL_LOGOS_SUCCESS,
  UPLOAD_FILE_TYPE_UNSUPPORTED,
  UPLOAD_FILE_SIZE_LIMIT,
  UPLOAD_IMAGE_RESOLUTION_LIMIT,
  UPLOAD_FILE_NAME_UNSUPPORTED_SYMBOLS
} from '../actions/general';

import {
  CREATE_SUBSCRIPTION_TIER_SUCCESS,
  CREATE_SUBSCRIPTION_TIER_FAILED,
  UPDATE_SUBSCRIPTION_TIER_SUCCESS,
  UPDATE_SUBSCRIPTION_TIER_FAILED,
  DELETE_SUBSCRIPTION_TIER_SUCCESS,
  DELETE_SUBSCRIPTION_TIER_FAILED,
  UPDATE_USER_SUBSCRIPTION_PLAN_SUCCESS,
  UPDATE_USER_SUBSCRIPTION_PLAN_FAILED,
  UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_SUCCESS,
  UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_FAILED,
  CREATE_CUSTOMER_ACCOUNT_SUCCESS,
  CREATE_CUSTOMER_ACCOUNT_FAILED,
  REQUEST_TAX_RATES_CONFIGURATIONS_SUCCESS,
  REQUEST_TAX_RATES_CONFIGURATIONS_FAILED,
  USER_SIGNUP_ONELOGIN_SUCCESS,
  USER_SIGNUP_ONELOGIN_FAILED,
  REPLACE_USER_CREDIT_CARD_SUCCESS,
  REPLACE_USER_CREDIT_CARD_FAILED,
  DELETE_USER_CREDIT_CARD_SUCCESS,
  DELETE_USER_CREDIT_CARD_FAILED,
  USER_PROFILE_UPDATE_SUCCESS,
  USER_PROFILE_UPDATE_FAILED
} from '../actions/user';

import {
  SAVE_BANNER_SLIDE_SUCCESS,
  SAVE_BANNER_SLIDE_FAILED,
  DELETE_BANNER_SLIDE_SUCCESS,
  DELETE_BANNER_SLIDE_FAILED,
  ADD_NEW_BANNER_SLIDE_SUCCESS,
  ADD_NEW_BANNER_SLIDE_FAILED
} from '../actions/banner_manager';

import  {
  SAVE_REFERRAL_RULE_FAILED,
  SAVE_REFERRAL_RULE_SUCCESS,
  DELETE_REFERRAL_RULE_FAILED,
  DELETE_REFERRAL_RULE_SUCCESS
} from '../actions/referral_program';

import {
  ADD_AFFILIATES_BANNER_SLIDE_SUCCESS,
  ADD_AFFILIATES_BANNER_SLIDE_FAILED,
  DELETE_AFFILIATES_BANNER_SLIDE_SUCCESS,
  DELETE_AFFILIATES_BANNER_SLIDE_FAILED,
  EDIT_AFFILIATES_BANNER_SLIDE_SUCCESS,
  EDIT_AFFILIATES_BANNER_SLIDE_FAILED,
  SEND_REQUEST_PRODUCTS_EMAIL_SUCCESS,
  SEND_REQUEST_PRODUCTS_EMAIL_FAILED
} from '../actions/partners';

import { CREATE_STRIPE_ACCOUNT_FAILED } from '../actions/stripe';

import {
  GET_ASSET_MANAGER_IMAGES_FAILED,
  UPLOAD_PROVIDER_IMAGE_SUCCESS,
  UPLOAD_PROVIDER_IMAGE_FAILED,
  UPLOAD_PRIVATE_IMAGE_SUCCESS,
  UPLOAD_PRIVATE_IMAGE_FAILED
} from '../actions/asset_manager';

import {
  SAVE_STORE_STYLES_SUCCESS,
  SAVE_STORE_STYLES_FAILED
} from '../actions/styles_palette';

import {
  SEND_DNS_CONFIGURATIONS_SUCCESS,
  SEND_DNS_CONFIGURATIONS_FAILED,
  VERIFY_DNS_CONFIGURATIONS_SUCCESS,
  VERIFY_DNS_CONFIGURATIONS_FAILED
} from '../actions/dns_manager';

import {
  SAVE_APPOINTMENT_BUTTON_CONFIGS_SUCCESS,
  SAVE_APPOINTMENT_BUTTON_CONFIGS_FAILED,
  SAVE_BOOK_NOW_BUTTON_CONFIGS_SUCCESS,
  SAVE_BOOK_NOW_BUTTON_CONFIGS_FAILED
} from '../actions/buttons_configs';

import {
  ADD_HELP_CATEGORY_SUCCESS,
  ADD_HELP_CATEGORY_FAILED,
  EDIT_HELP_CATEGORY_SUCCESS,
  EDIT_HELP_CATEGORY_FAILED,
  ADD_HELP_SUB_CATEGORY_SUCCESS,
  ADD_HELP_SUB_CATEGORY_FAILED,
  EDIT_HELP_SUB_CATEGORY_SUCCESS,
  EDIT_HELP_SUB_CATEGORY_FAILED,
  ADD_HELP_TOPIC_SUCCESS,
  ADD_HELP_TOPIC_FAILED,
  EDIT_HELP_TOPIC_SUCCESS,
  EDIT_HELP_TOPIC_FAILED
} from '../actions/help';

import {
  EDIT_TAX_RATE_SUCCESS,
  EDIT_TAX_RATE_FAILED,
  CREATE_NEW_TAX_RATES_SUCCESS,
  CREATE_NEW_TAX_RATES_FAILED,
  DELETE_TAX_RATE_SUCCESS,
  DELETE_TAX_RATE_FAILED
} from '../actions/tax_rates';

import {
  CREATE_MARKETING_BILLING_SUCCESS,
  CREATE_MARKETING_BILLING_FAILED,
  CREATE_ADDITIONAL_SKUS_SUCCESS,
  CREATE_ADDITIONAL_SKUS_FAILED,
  EDIT_ADDITIONAL_SKUS_SUCCESS,
  EDIT_ADDITIONAL_SKUS_FAILED,
  DELETE_ADDITIONAL_SKUS_SUCCESS,
  DELETE_ADDITIONAL_SKUS_FAILED,
  CREATE_ADDITIONAL_FEATURES_SUCCESS,
  CREATE_ADDITIONAL_FEATURES_FAILED,
  EDIT_ADDITIONAL_FEATURES_SUCCESS,
  EDIT_ADDITIONAL_FEATURES_FAILED,
  DELETE_ADDITIONAL_FEATURES_SUCCESS,
  DELETE_ADDITIONAL_FEATURES_FAILED,
  CREATE_ADDITIONAL_SPECIALS_SUCCESS,
  CREATE_ADDITIONAL_SPECIALS_FAILED,
  EDIT_ADDITIONAL_SPECIALS_SUCCESS,
  EDIT_ADDITIONAL_SPECIALS_FAILED,
  DELETE_ADDITIONAL_SPECIALS_SUCCESS,
  DELETE_ADDITIONAL_SPECIALS_FAILED,
  BILL_STORE_FROM_ONBOARDING_SUCCESS,
  BILL_STORE_FROM_ONBOARDING_FAILED,
  SAVE_ONBOARDING_DATA_FAILED,
  SAVE_MARKETING_DATA_FAILED,
  UPDATE_SUBSCRIPTION_SETUP_SUCCESS,
  UPDATE_SUBSCRIPTION_SETUP_FAILED
} from '../actions/subscription';
import {
  RESEND_ORDER_EMAIL_SUCCESS,
  RESEND_ORDER_EMAIL_FAILED,
  UPDATE_STORE_ORDER_SUCCESS,
  UPDATE_STORE_ORDER_FAILED,
  REFUND_ORDER_FAILED,
  REFUND_ORDER_SUCCESS,
  SHIP_ORDER_SUCCESS,
  SHIP_ORDER_FAILED,
  GENERATE_ORDERS_INVOICE_PDF_FAILED,
  UNHOLD_ORDERS_SUCCESS,
  UNHOLD_ORDERS_FAILED,
  HOLD_ORDERS_SUCCESS,
  HOLD_ORDERS_FAILED,
  UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_SUCCESS,
  UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_FAILED,
} from '../actions/store_orders';
import {
  EDIT_STORE_CUSTOMER_DEFAULT_GROUP_SUCCESS,
  EDIT_STORE_CUSTOMER_DEFAULT_GROUP_FAILED,
  DELETE_CUSTOMER_ACCOUNT_SUCCESS,
  DELETE_CUSTOMER_ACCOUNT_FAILED,
  RESET_CUSTOMER_PASSWORD_SUCCESS,
  RESET_CUSTOMER_PASSWORD_FAILED,
  UPDATE_CUSTOMER_DATA_SUCCESS,
  UPDATE_CUSTOMER_DATA_FAILED,
  CREATE_CUSTOMER_SUCCESS,
  CREATE_CUSTOMER_FAILED,
  UPDATE_CUSTOMER_REWARDS_BALANCE_SUCCESS,
  UPDATE_CUSTOMER_REWARDS_BALANCE_FAILED,
  UPDATE_CUSTOMERS_ACCESS_SUCCESS,
  UPDATE_CUSTOMERS_ACCESS_FAILED,
  UPDATE_CUSTOMER_GIFTCARDS_BALANCE_SUCCESS,
  UPDATE_CUSTOMER_GIFTCARDS_BALANCE_FAILED,
  ADD_IMPORT_CUSTOMERS_TO_QUEUE_FAILED,
  RECEIVE_CUSTOMERS_IMPORT_QUEUE_TASK_UPDATE,
  DELETE_IMPORT_CUSTOMER_QUEUE_TASK_SUCCESS,
  DELETE_IMPORT_CUSTOMER_QUEUE_TASK_FAILED,
  GET_EXISTING_CUSTOMERS_BY_EMAILS_FAILED
} from '../actions/customers';

import {
  CREATE_QUOTEPRO_CUSTOMER_SUCCESS,
  CREATE_QUOTEPRO_CUSTOMER_FAILED,
  UPDATE_QUOTE_CUSTOMER_SUCCESS,
  UPDATE_QUOTE_CUSTOMER_FAILED,
  UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_SUCCESS,
  UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_FAILED,
  UPDATE_QUOTEPRO_LISTINGS_SUCCESS,
  UPDATE_QUOTEPRO_LISTINGS_FAILED,
  ADD_ITEMS_TO_QUOTE_SUCCESS,
  ADD_ITEMS_TO_QUOTE_FAILED,
  CREATE_QUOTEPRO_PACKAGE_SUCCESS,
  CREATE_QUOTEPRO_PACKAGE_FAILED,
  DELETE_QUOTE_ITEM_SUCCESS,
  DELETE_QUOTE_ITEM_FAILED,
  CONVERT_QUOTE_SUCCESS,
  CONVERT_QUOTE_FAILED,
  GET_QUOTE_TOTALS_FAILED,
  QUOTEPRO_PLACE_ORDER_COMBINED_SUCCESS,
  QUOTEPRO_PLACE_ORDER_COMBINED_FAILED,
  DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_SUCCESS,
  DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_FAILED,
  UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_SUCCESS,
  UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_FAILED,
  GET_QUOTE_ITEMS_COMBINED_FAILED,
  PUBLISH_PUSH_CART_ITEMS_SUCCESS,
  PUBLISH_PUSH_CART_ITEMS_FAILED,
  PUBLISH_PUSHCART_TREATMENTS_SUCCESS,
  PUBLISH_PUSHCART_TREATMENTS_FAILED,
  CREATE_PATIENTS_GROUP_QUOTE_SUCCESS,
  CREATE_PATIENTS_GROUP_QUOTE_FAILED,
  GET_CUSTOMER_PUSH_CART_FAILED,
  OPEN_CHECKOUT_FAILED,
  CREATE_ACTIVE_CART_COMBINED_FAILED,
  DELETE_QUOTEPRO_PACKAGE_FAILED,
  DELETE_QUOTEPRO_PACKAGE_SUCCESS,
  DELETE_TERMS_AND_CONDITIONS_SUCCESS,
  DELETE_TERMS_AND_CONDITIONS_FAILED,
  SAVE_TERMS_AND_CONDITIONS_SUCCESS,
  SAVE_TERMS_AND_CONDITIONS_FAILED,
  DELETE_DEAL_TASK_SUCCESS,
  DELETE_DEAL_TASK_FAILED,
  UPDATE_DEAL_TASK_SUCCESS,
  UPDATE_DEAL_TASK_FAILED,
  CREATE_DEAL_TASK_SUCCESS,
  CREATE_DEAL_TASK_FAILED,
  CREATE_DEAL_ACTIVITY_SUCCESS,
  CREATE_DEAL_ACTIVITY_FAILED,
  UPDATE_DEAL_ACTIVITY_SUCCESS,
  UPDATE_DEAL_ACTIVITY_FAILED,
  DELETE_DEAL_ACTIVITY_SUCCESS,
  DELETE_DEAL_ACTIVITY_FAILED,
  CREATE_DRAFT_QUOTE_SUCCESS,
  CREATE_DRAFT_QUOTE_FAILED,
  OPEN_CHECKOUT_SERVICE_FOR_DRAFTED_QUOTE_FAILED,
  UPDATE_DRAFT_QUOTE_BY_ID_SUCCESS,
  UPDATE_DRAFT_QUOTE_BY_ID_FAILED,
  PUBLISH_DRAFT_QUOTE_BY_ID_SUCCESS,
  PUBLISH_DRAFT_QUOTE_BY_ID_FAILED,
  DELETE_MARKETING_SEGMENTS_QUEUE_TASK_SUCCESS,
  DELETE_MARKETING_SEGMENTS_QUEUE_TASK_FAILED,
  UPDATE_CUSTOMER_PUSH_CART_FAILED
} from '../actions/quote';

import {
  CREATE_SM_BANNER_SUCCESS,
  CREATE_SM_BANNER_FAILED,
  UPDATE_SM_BANNER_SUCCESS,
  UPDATE_SM_BANNER_FAILED,
  DELETE_SM_BANNER_SUCCESS,
  DELETE_SM_BANNER_FAILED,
  SEND_REQUEST_INFORMATION_EMAIL_SUCCESS,
  SEND_REQUEST_INFORMATION_EMAIL_FAILED
} from '../actions/home';

import {
  ADD_EAV_ATTRIBUTE_SUCCESS,
  ADD_EAV_ATTRIBUTE_FAILED,
  UPDATE_EAV_ATTRIBUTE_SUCCESS,
  UPDATE_EAV_ATTRIBUTE_FAILED,
  DELETE_EAV_ATTRIBUTE_SUCCESS,
  DELETE_EAV_ATTRIBUTE_FAILED,
} from '../actions/eavAttributes';

import {
  EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_FAILED,
  EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_SUCCESS,
  EDIT_CUSTOMER_SUBSCRIPTION_FAILED,
  EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_FAILED,
  EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_SUCCESS,
  EDIT_CUSTOMER_SUBSCRIPTION_SUCCESS,
  BILL_CUSTOMER_SUBSCRIPTION_SUCCESS,
  BILL_CUSTOMER_SUBSCRIPTION_FAILED,
} from '../actions/customer_subscriptions';

import {
  EDIT_DEPOSIT_SUCCESS,
  EDIT_DEPOSIT_FAILED,
  EDIT_DEPOSIT_PAYMENT_SUCCESS,
  EDIT_DEPOSIT_PAYMENT_FAILED
} from '../actions/deposits';
import {
  CREATE_GIFT_CARD_CODE_SUCCESS,
  CREATE_GIFT_CARD_CODE_FAILED
} from '../actions/gift_card';

import {
  EDIT_MARKETING_SEGMENTS_CUSTOMER_FAILED,
  EDIT_MARKETING_SEGMENTS_CUSTOMER_SUCCESS
} from '../actions/quote_marketing_segments';

import {
  CREATE_AUTO_QUOTE_SUCCESS,
  CREATE_AUTO_QUOTE_FAILED,
  EDIT_AUTO_QUOTE_SCHEDULE_SUCCESS,
  EDIT_AUTO_QUOTE_SCHEDULE_FAILED,
  DELETE_AUTO_QUOTE_SCHEDULE_SUCCESS,
  DELETE_AUTO_QUOTE_SCHEDULE_FAILED
} from '../actions/automated_quotes';

import * as rpaActions from '../actions/rpa';


const initialState = {
  notificationsStack: []
};

const formReducer = produce((state: IUIState = initialState, action) => {
  switch (action.type) {
    case CLOSE_SNACKBAR_NOTIFICATION: {
      const {key} = action;
      state.notificationsStack = state.notificationsStack.filter((n) => n.key !== key);
      break;
    }
    case SHOW_NOTIFICATION: {
      const {notificationType = 'success', message } = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message,
        type: notificationType,
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_EAV_ATTRIBUTE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Failed while adding. Error: ${action.error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_EAV_ATTRIBUTE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Marketing Segments successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_EAV_ATTRIBUTE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Failed while updating. Error: ${action.error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_EAV_ATTRIBUTE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Marketing Segments successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_EAV_ATTRIBUTE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Failed while deleting. Error: ${action.error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_EAV_ATTRIBUTE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Marketing Segments successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case GET_STORE_PRODUCTS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Products loading error.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case GET_CATEGORY_PRODUCTS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Category loading error.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_SUBSCRIPTION_OPTION_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Subscription option added successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_SUBSCRIPTION_OPTION_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Subscription option add failed.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_SUBSCRIPTION_OPTION_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Subscription option edited successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_SUBSCRIPTION_OPTION: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Subscription option deleted successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Successfully saved',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Can't save. Error:${error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_STORE_PRODUCT_MEDIA_GALLERY_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Image saved.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_STORE_PRODUCT_MEDIA_GALLERY_FAILED: {
      const {e} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Image failed to save. ${e.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case RECEIVE_QUEUED_TASK_UPDATE: {
      const { action: taskAction, task } = action.data;
      const { error, requestType, body } = task;

      if (error) {
        state.notificationsStack = [...state.notificationsStack, {
          isOpen: true,
          message: `Error occurred during ${taskAction}, ${error.message}`,
          type: 'error',
          key: new Date().getTime()
        }];
      } else if (taskAction === 'TASK_COMPLETED' && requestType === 'UPDATE_PRODUCT' && body?.custom_attributes?.some((attr) => attr.attribute_code === 'subscription_active')) {
        state.notificationsStack = [...state.notificationsStack, {
          isOpen: true,
          message: 'Successfully saved',
          type: 'success',
          key: new Date().getTime()
        }];
      }

      break;
    }

    case RECEIVE_CUSTOMERS_IMPORT_QUEUE_TASK_UPDATE: {
      const {task} = action.data;
      const {error} = task;

      if (error) {
        state.notificationsStack = [...state.notificationsStack, {
          isOpen: true,
          message: error.message,
          type: 'error',
          key: new Date().getTime()
        }];
      }

      break;
    }

    case DELETE_IMPORT_CUSTOMER_QUEUE_TASK_FAILED: {
      const { error } = action.error.response.data;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_IMPORT_CUSTOMER_QUEUE_TASK_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Deleted successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case REMOVE_TASK_FROM_QUEUE_FAILED: {
      const { error } = action.error.response.data;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_SUBSCRIPTION_OPTION_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Product subscription edit failed.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_SUBSCRIPTION_OPTION_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Subscription option deletion failed.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_CUSTOM_OPTION_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Custom option update failed.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_CUSTOM_OPTION_VALUE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Custom option update failed.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_CUSTOM_OPTION_VALUE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Custom option successfully deleted.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_CUSTOM_OPTION_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Custom option successfully deleted. ',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_CUSTOM_OPTION_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Custom option update failed.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_CUSTOM_OPTION_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Custom option successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_CUSTOM_OPTIONS_PRICE_TYPES_FAILED: {
      const { error } = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Price update error. ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_CUSTOM_OPTIONS_PRICE_TYPES_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Custom option successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_CUSTOM_OPTION_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Custom option update failed.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_CUSTOM_OPTION_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Custom option successfully added.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_STORE_EARNING_RULES_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Error saving Earning Rule.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_STORE_SPENDING_RULES_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Error saving Spending Rule.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case GET_REWARD_BEHAVIOR_RULES_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Earning Rule error.',
        type: 'warning',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_STORE_REWARD_BEHAVIOUR_RULES_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Error saving Earning Rule.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_REWARD_BEHAVIOR_RULE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Rule saved successful',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_REWARD_BEHAVIOR_RULE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Earning Rule error.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_STORE_CONFIGS_SUCCESS: {
      if (state.notificationsStack.length < 1) {
        state.notificationsStack = [...state.notificationsStack, {
          isOpen: true,
          message: 'Store Configuration saved.',
          type: 'success',
          key: new Date().getTime()
        }];
      }

      break;
    }

    case UPDATE_STORE_SITE_MAP_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Error with saving Reward Program status',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_CATEGORY_PRODUCTS_SUCCESS: {
      if (state.notificationsStack.length < 1) {
        state.notificationsStack = [...state.notificationsStack, {
          isOpen: true,
          message: 'Configurations saved successfully.',
          type: 'success',
          key: new Date().getTime()
        }];
      }

      break;
    }

    case DELETE_USER_STORE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store is removed from user account successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_USER_STORE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store is not removed. Something wrong',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_USER_STORE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store is added successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_USER_STORE_FAILED: {
      const { error } = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Store is not added. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_NEW_TAX_RATES_FAILED: {
      const { error } = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error: ${error.message}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_NEW_TAX_RATES_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store configuration saved.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_TAX_RATE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_TAX_RATE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store configuration saved.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_TAX_RATE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_TAX_RATE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store configuration saved.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_EDITED_STORE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Data saved successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_EDITED_STORE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_PERMISSION_CONFIG_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.data.message,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case CREATE_PERMISSION_CONFIG_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_PERMISSION_CONFIG_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'User permission updated successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case UPDATE_PERMISSION_CONFIG_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }


    case DELETE_PERMISSION_CONFIG_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.data.message,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case DELETE_PERMISSION_CONFIG_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_SM_USER_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.data.message,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case CREATE_SM_USER_FAILED: {
      const { error } = action.error.response.data;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_USER_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'User deleted successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_USER_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'User account is not deleted. Something wrong',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_STORE_SUCCESS: {
      const { message } = action.data;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_STORE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store is not deleted. Something wrong',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_STORE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store is added successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_STORE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_STORE_CATEGORY_SUCCESS: {
      if (state.notificationsStack.length < 1) {
        state.notificationsStack = [...state.notificationsStack, {
          isOpen: true,
          message: 'Configurations are saved successfully',
          type: 'success',
          key: new Date().getTime()
        }];
      }

      break;
    }

    case SAVE_STORE_CATEGORY_FAILED: {
      const {category} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Can't save "${category.name}" category`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_REQUEST_SKU_EMAIL_DATA_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Thank you for your request, we will be in touch with you soon.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_REQUEST_SKU_EMAIL_DATA_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Something went wrong! Try again later or contact our support team.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_REQUEST_PROMOTION_EMAIL_DATA_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Thank you for your request, we will be in touch with you soon.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_REQUEST_PROMOTION_EMAIL_DATA_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Something went wrong! Try again later or contact our support team.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Thank you for your request, we will be in touch with you soon.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Something went wrong! Try again later or contact our support team.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPLOAD_IMAGE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: ' Image successfully uploaded',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPLOAD_IMAGE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Can\'t upload image! Try again later or contact our support team.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case REMOVE_UPLOADED_IMAGE: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: ' Image successfully deleted',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_PRODUCT_TO_STORE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Product added to store successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_PRODUCT_TO_STORE_FAILED: {
      const {product, error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Can't publish ${product.name}. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case MASS_ADD_PRODUCT_TO_STORE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Products published.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case MASS_ADD_PRODUCT_TO_STORE_WARNING: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Error occurred during publishing. Some of your products were not published. Please contact support.',
        type: 'warning',
        key: new Date().getTime()
      }];
      break;
    }
    case MASS_ADD_PRODUCT_TO_STORE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Error occurred during publishing. Please contact support.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case GET_FRAUD_ORDERS_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_FRAUD_ORDER_STATUS_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Can't update order status. Error:${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_FRAUD_ORDER_STATUS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Order Status is updated successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_STORE_PRODUCT_SUCCESS: {
      const {showMessage} = action;

      if (showMessage) {
        state.notificationsStack = [...state.notificationsStack, {
          isOpen: true,
          message: 'Changes saved.',
          type: 'success',
          key: new Date().getTime()
        }];
      }

      break;
    }

    case DELETE_STORE_PRODUCT_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Product deleted.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_STORE_PRODUCT_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Error deleting product.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_STORE_PICKUP_LOCATION_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Error',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_STORE_PICKUP_LOCATION_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store location change successfully saved.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_STORE_PICKUP_LOCATION_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Error',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_STORE_PICKUP_LOCATION_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store location change successfully saved.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_STORE_PICKUP_LOCATION_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Error',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_STORE_PICKUP_LOCATION_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store location change successfully saved.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_STORE_PICKUP_CONFIG_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Can\'t update Store Pickup Configuration',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_STORE_PICKUP_CONFIG_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store location change successfully saved.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case GET_SOCIAL_MEDIA_CONFIGS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Social Media configuration failed.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_SOCIAL_MEDIA_CONFIGS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Social Media configuration failed.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_SOCIAL_MEDIA_CONFIGS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Social Media configuration saved.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_NOTIFICATION_OPTIONS_SUCCESS: {
      if (state.notificationsStack.length < 1) {
        state.notificationsStack = [...state.notificationsStack, {
          isOpen: true,
          message: 'Store Configuration saved.',
          type: 'success',
          key: new Date().getTime()
        }];
      }

      break;
    }

    case SAVE_NOTIFICATION_OPTIONS_WARNING: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Error occurred during saving. Some of your configuration were not saved.',
        type: 'warning',
        key: new Date().getTime()
      }];

      break;
    }

    case SAVE_NOTIFICATION_OPTIONS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Error occurred during saving, please contact support',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Configurations saved successfully.',
        type: 'success',
        key: new Date().getTime()
      }];

      break;
    }

    case SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error occurred during saving. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case GET_APPOINTMENT_FORM_CONFIGS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error occurred during saving. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }


    case SAVE_APPOINTMENT_FORM_CONFIGS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Configurations saved successfully.',
        type: 'success',
        key: new Date().getTime()
      }];

      break;
    }

    case SAVE_APPOINTMENT_FORM_CONFIGS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error occurred during saving. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Homepage Welcome content saved.',
        type: 'success',
        key: new Date().getTime()
      }];

      break;
    }

    case SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error occurred during saving. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Configurations saved successfully.',
        type: 'success',
        key: new Date().getTime()
      }];

      break;
    }

    case SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error occurred during saving. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Configurations saved successfully.',
        type: 'success',
        key: new Date().getTime()
      }];

      break;
    }

    case SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error occurred during saving. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_ABOUT_US_PAGE_CONFIGS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Configurations saved successfully.',
        type: 'success',
        key: new Date().getTime()
      }];

      break;
    }

    case SAVE_ABOUT_US_PAGE_CONFIGS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error occurred during saving. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_STORE_CONTACTS_CONFIGS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error occurred during saving. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_STORE_NAME_FAILED : {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error occurred during saving. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case REMOVE_FBT_LINK_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error removing related product. ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case REMOVE_FBT_LINK_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Related product removed.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_FBT_LINKS_WARNING: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Error saving related product.',
        type: 'warning',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_FBT_LINKS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error saving related product. ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_FBT_LINKS_SUCCESS: {
      if (state.notificationsStack.length < 1) {
        state.notificationsStack = [...state.notificationsStack, {
          isOpen: true,
          message: 'Related product saved.',
          type: 'success',
          key: new Date().getTime()
        }];
      }

      break;
    }

    case EDIT_STORE_PRODUCT_UPSELL_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Related product saved.',
        type: 'success',
        key: new Date().getTime()
      }];

      break;
    }

    case EDIT_STORE_PRODUCT_UPSELL_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error saving related product. ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case REMOVE_STORE_PRODUCT_RELATED_LINKS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Related product removed.',
        type: 'success',
        key: new Date().getTime()
      }];

      break;
    }

    case REMOVE_STORE_PRODUCT_RELATED_LINKS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error removing related product. ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_STORE_PRODUCT_CROSS_SELL_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Related product saved.',
        type: 'success',
        key: new Date().getTime()
      }];

      break;
    }

    case EDIT_STORE_PRODUCT_CROSS_SELL_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error saving related product. ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case GENERATE_COUPON_FOR_EMAIL_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Can't generate Coupon. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case GENERATE_COUPON_FOR_EMAIL_SUCCESS: {
      const {data: {messages}} = action;

      messages.map((msg) => {
        return state.notificationsStack = [...state.notificationsStack, {
          isOpen: true,
          message: `${msg}`,
          type: 'success',
          key: new Date().getTime()
        }];
      });
      break;
    }

    case GENERATE_COUPON_RULE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't create Coupon Rule. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case GENERATE_COUPON_RULE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Coupon code successfully generated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_COUPON_RULE_COMBINED_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't update Coupon Rule. ${error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_COUPON_RULE_COMBINED_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Coupon Rule successfully updated',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_COUPON_RULE_COMBINED_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't create Coupon Rule. Error: ${error.message}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_COUPON_RULE_COMBINED_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Coupon rule successfully created',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_COUPON_RULE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't delete Coupon Rule. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_COUPON_RULE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Coupon Rule deleted successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_CMS_PAGE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't update this page. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case UPDATE_CMS_PAGE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Page successfully updated',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case CREATE_PROMO_BY_TEMPLATE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Promotion was published successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case CREATE_PROMO_BY_TEMPLATE_FAILED: {
      // const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case CANCEL_PROMOTION_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Promotion was canceled successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case CANCEL_PROMOTION_FAILED: {
      state.notificationsStack = [{
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case RESCHEDULE_PROMOTION_FAILED: {
      state.notificationsStack = [{
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case RESCHEDULE_PROMOTION_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Promo is successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_SUCCESS: {
      state.notificationsStack = [{
        isOpen: true,
        message: action.data.message,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_FAILED: {
      state.notificationsStack = [{
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case DELETE_SINGLE_TEMPLATE_SUCCESS: {
      state.notificationsStack = [{
        isOpen: true,
        message: 'Template was delete successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case DELETE_SINGLE_TEMPLATE_FAILED: {
      state.notificationsStack = [{
        isOpen: true,
        message: 'Error while delete template',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case UPLOAD_STORE_LOGOS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't update logo. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case UPLOAD_STORE_LOGOS_TYPE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Sorry, we can\'t update logo. Error: type not supported.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case UPLOAD_STORE_LOGOS_SUCCESS: {
      const {key} = action;

      if (key !== 'invoice_html') {
        state.notificationsStack = [...state.notificationsStack, {
          isOpen: true,
          message: 'Logo successfully loaded',
          type: 'success',
          key: new Date().getTime()
        }];
      }

      break;
    }
    case UPDATE_ALL_LOGOS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Upload images are failed',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case UPDATE_ALL_LOGOS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Configurations are saved successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case UPLOAD_FILE_TYPE_UNSUPPORTED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Sorry, we can\'t upload image. Error: type not supported.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case UPLOAD_FILE_SIZE_LIMIT: {
      const {sizeLimit = '1 MB'} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't upload image. Error: file size more than ${sizeLimit}.`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case UPLOAD_IMAGE_RESOLUTION_LIMIT: {
      const { resolutionLimit } = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't upload image. Error: image size should be ${resolutionLimit}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case UPLOAD_FILE_NAME_UNSUPPORTED_SYMBOLS: {
      const {fileName} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't upload image with name - ${fileName}.
          Error: image name shouldn't includes next symbols ^/?*:{"}';<>()|{}\\`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case CREATE_SUBSCRIPTION_TIER_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't create tier. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case CREATE_SUBSCRIPTION_TIER_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Tier was successfully created.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_SUBSCRIPTION_TIER_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't save tier. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case UPDATE_SUBSCRIPTION_TIER_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Tier was successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_SUBSCRIPTION_TIER_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't delete tier. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case DELETE_SUBSCRIPTION_TIER_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Tier was successfully deleted.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_USER_SUBSCRIPTION_PLAN_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't update your subscription plan. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case UPDATE_USER_SUBSCRIPTION_PLAN_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Subscription Plan is successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't update current subscription plan. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case   UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Subscription Plan is successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SEND_DIRECT_FULFILLMENT_REQUEST_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Thank you for your request. We will be in touch with you soon.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SEND_DIRECT_FULFILLMENT_REQUEST_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Fulfillment request failed. Please contact our support team.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_BANNER_SLIDE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Banner saved successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_BANNER_SLIDE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't update slide. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_BANNER_SLIDE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Banner deleted successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_BANNER_SLIDE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't delete slide. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_NEW_BANNER_SLIDE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Banner added to draft.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_NEW_BANNER_SLIDE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't add slide. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_CUSTOMER_ACCOUNT_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Your request was send successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_CUSTOMER_ACCOUNT_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't send your request. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case REQUEST_TAX_RATES_CONFIGURATIONS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Your request was send successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case REQUEST_TAX_RATES_CONFIGURATIONS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't send your request. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case USER_SIGNUP_ONELOGIN_SUCCESS: {
      const {data: {message}} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case USER_SIGNUP_ONELOGIN_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't create user. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_REFERRAL_RULE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't add referral rule: ${error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_REFERRAL_RULE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Referral rule is successfully added.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_REFERRAL_RULE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Referral rule is successfully deleted.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_REFERRAL_RULE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Referral rule is not deleted:${error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_AFFILIATES_BANNER_SLIDE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Banner saved successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_AFFILIATES_BANNER_SLIDE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error:${error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }


    case DELETE_AFFILIATES_BANNER_SLIDE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Banner deleted successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_AFFILIATES_BANNER_SLIDE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error:${error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_AFFILIATES_BANNER_SLIDE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Banner edited.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_AFFILIATES_BANNER_SLIDE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error:${error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_STRIPE_ACCOUNT_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case GET_ASSET_MANAGER_IMAGES_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Error occurred while fetching images',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPLOAD_PROVIDER_IMAGE_SUCCESS: {
      const {data} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: data.message,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPLOAD_PROVIDER_IMAGE_FAILED: {
      const {error} = action;
      const message = JSON.parse(error.response.data.error)?.violationList?.[0]?.message ||
                      'Error occurs while upload image, please try again later.';
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPLOAD_PRIVATE_IMAGE_SUCCESS: {
      const {data} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: data.message,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPLOAD_PRIVATE_IMAGE_FAILED: {
      const {error} = action;
      const message = JSON.parse(error.response.data.error)?.violationList?.[0]?.message ||
                      'Error occurs while upload image, please try again later.';
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_STORE_STYLES_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Configurations successfully saved',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_STORE_STYLES_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't save configurations. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SEND_DNS_CONFIGURATIONS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Email sent successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SEND_DNS_CONFIGURATIONS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Sorry, we can't send email. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case VERIFY_DNS_CONFIGURATIONS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'DNS verified successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case VERIFY_DNS_CONFIGURATIONS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'DNS records are not correct. Please add data from the table below to your host’s DNS section',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_BOOK_NOW_BUTTON_CONFIGS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Configurations successfully saved',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_APPOINTMENT_BUTTON_CONFIGS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Configurations successfully saved',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_APPOINTMENT_BUTTON_CONFIGS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_BOOK_NOW_BUTTON_CONFIGS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_HELP_CATEGORY_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Main Category successfully saved',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_HELP_SUB_CATEGORY_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Sub-Category successfully saved',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_HELP_TOPIC_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Topic successfully saved',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_HELP_CATEGORY_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_HELP_SUB_CATEGORY_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_HELP_TOPIC_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_HELP_CATEGORY_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Main Category successfully updated',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_HELP_SUB_CATEGORY_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Sub-Category successfully updated',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_HELP_TOPIC_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Topic successfully updated',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_HELP_CATEGORY_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_HELP_SUB_CATEGORY_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_HELP_TOPIC_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_SUBSCRIPTION_COUPON_CODE_SUCCESS: {
      const { message } = action.data;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_SUBSCRIPTION_COUPON_CODE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_SUBSCRIPTION_COUPON_CODE_SUCCESS: {
      const { message } = action.data;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_SUBSCRIPTION_COUPON_CODE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_SUBSCRIPTION_COUPON_CODE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Code was successfully deleted',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_SUBSCRIPTION_COUPON_CODE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case BILL_STORE_FROM_ONBOARDING_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Purchase is successful',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case BILL_STORE_FROM_ONBOARDING_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case REPLACE_USER_CREDIT_CARD_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Card was replaced successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case REPLACE_USER_CREDIT_CARD_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }


    case DELETE_USER_CREDIT_CARD_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Card was deleted successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_USER_CREDIT_CARD_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_ONBOARDING_DATA_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case SAVE_MARKETING_DATA_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_MARKETING_BILLING_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_ADDITIONAL_SKUS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Additional SKUs created successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_ADDITIONAL_SKUS_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_ADDITIONAL_SPECIALS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Additional Specials created successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_ADDITIONAL_SPECIALS_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_ADDITIONAL_FEATURES_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Additional Features created successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_ADDITIONAL_FEATURES_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_ADDITIONAL_SKUS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Additional SKUs successfully updated',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_ADDITIONAL_SKUS_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_ADDITIONAL_SPECIALS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Additional Specials successfully updated',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_ADDITIONAL_SPECIALS_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_ADDITIONAL_FEATURES_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Additional Features successfully updated',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_ADDITIONAL_FEATURES_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_ADDITIONAL_SKUS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Additional SKUs successfully deleted',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_ADDITIONAL_SKUS_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_ADDITIONAL_SPECIALS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Additional Specials successfully deleted',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_ADDITIONAL_SPECIALS_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_ADDITIONAL_FEATURES_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Additional Features successfully deleted',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_ADDITIONAL_FEATURES_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case CREATE_MARKETING_BILLING_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Billing successfully created',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case RESEND_ORDER_EMAIL_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case RESEND_ORDER_EMAIL_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Order email successfully sent',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case UPDATE_STORE_ORDER_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case UPDATE_STORE_ORDER_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Order successfully updated',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case REFUND_ORDER_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Order successfully refunded',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case REFUND_ORDER_FAILED: {
      const {error} = action;

      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SHIP_ORDER_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Shipment data successfully saved',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SHIP_ORDER_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_CUSTOMER_ACCOUNT_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Account successfully deleted',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_CUSTOMER_ACCOUNT_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_STORE_CUSTOMER_DEFAULT_GROUP_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Customer Default Group successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_STORE_CUSTOMER_DEFAULT_GROUP_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case RESET_CUSTOMER_PASSWORD_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'The customer will receive an email with a link to reset password.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case RESET_CUSTOMER_PASSWORD_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_CUSTOMER_DATA_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Successfully saved',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_CUSTOMER_DATA_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_CUSTOMER_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Customer Account successfully created',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_CUSTOMER_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_CUSTOMER_REWARDS_BALANCE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Rewards Balance successfully updated',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_CUSTOMER_REWARDS_BALANCE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response?.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_CUSTOMER_GIFTCARDS_BALANCE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Gift Cards balance successfully updated',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_CUSTOMER_GIFTCARDS_BALANCE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response?.data.error || 'Gift Cards balance update failed.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_QUOTEPRO_CUSTOMER_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Patient Account successfully created',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_QUOTEPRO_CUSTOMER_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_QUOTE_CUSTOMER_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Patient Account successfully updated',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_QUOTE_CUSTOMER_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_IMPORT_CUSTOMERS_TO_QUEUE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response?.data.error || 'Customers import failed.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case GET_EXISTING_CUSTOMERS_BY_EMAILS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response?.data.error || 'Failed to check existing customers by email.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Groups update failed. Error: ${action.error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Groups successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_QUOTEPRO_LISTINGS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Item update failed. Error: ${action.error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_QUOTEPRO_LISTINGS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Item successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_ITEMS_TO_QUOTE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Can\'t add current item.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case ADD_ITEMS_TO_QUOTE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Successfully added.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_QUOTE_ITEM_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Can\'t delete current item.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_QUOTE_ITEM_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Successfully deleted.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CONVERT_QUOTE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Can\'t create quote.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CONVERT_QUOTE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Quote successfully created.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case GET_QUOTE_TOTALS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Can\'t proceed to Pay Now page.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case OPEN_CHECKOUT_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Can\'t proceed to checkout.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case QUOTEPRO_PLACE_ORDER_COMBINED_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Can\'t place order.Error: ${action.error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case QUOTEPRO_PLACE_ORDER_COMBINED_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Order successfully created.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Subscription option ${action.isNewOptions ? 'added' : 'edited'} successfully.`,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Product subscription ${action.isNewOptions ? 'adding' : 'edit'} failed.`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case GET_QUOTE_ITEMS_COMBINED_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Can't proceed next. Error: ${action.error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case PUBLISH_PUSH_CART_ITEMS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Quote created successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case PUBLISH_PUSH_CART_ITEMS_FAILED: {
      const isGhlError = action.error?.response?.status === 424;
      const serverError = action.error?.response?.data?.error;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: isGhlError
          ? `Quote created, but GHL returned an error. ${serverError}`
          : 'Can\'t create quote, try again later.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case PUBLISH_PUSHCART_TREATMENTS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Quotes created successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case PUBLISH_PUSHCART_TREATMENTS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Can\'t create quotes, try again later.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_PATIENTS_GROUP_QUOTE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Quote for Marketing Segment created successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_PATIENTS_GROUP_QUOTE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Can\'t create quote for Marketing Segment. Error: ${action.error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_DRAFT_QUOTE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Quote saved successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_DRAFT_QUOTE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Can\'t saved quote. Error: ${action.error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case OPEN_CHECKOUT_SERVICE_FOR_DRAFTED_QUOTE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Can\'t proceed to checkout. Error: ${action.error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_DRAFT_QUOTE_BY_ID_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Quote updated successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_DRAFT_QUOTE_BY_ID_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Can\'t updated quote. Error: ${action.error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case PUBLISH_DRAFT_QUOTE_BY_ID_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Quote created successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case PUBLISH_DRAFT_QUOTE_BY_ID_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Can\'t create quote. Error: ${action.error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_MARKETING_SEGMENTS_QUEUE_TASK_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Queue item deleted successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_MARKETING_SEGMENTS_QUEUE_TASK_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Can\'t delete queue item. Error: ${action.error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_CUSTOMER_PUSH_CART_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Error: ${action.error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Subscription option deleted successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Subscription option deletion failed.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_QUOTEPRO_PACKAGE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Can\'t create package. Try again later.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_QUOTEPRO_PACKAGE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Package was created successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_QUOTEPRO_PACKAGE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Package was deleted successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_QUOTEPRO_PACKAGE_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store Configuration saved.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store Configuration saved.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store Configuration saved.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Something went wrong. Please try again later.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_CUSTOMERS_ACCESS_SUCCESS: {
      const { updatedParamsAccess } = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: updatedParamsAccess[0].request_access === 'access_granted' ? 'Access status successfully granted.' : 'Access status successfully restricted.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_CUSTOMERS_ACCESS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Something went wrong. Please try again later.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store Configuration saved.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Something went wrong. Please try again later.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case USER_PROFILE_UPDATE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'User successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case USER_PROFILE_UPDATE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Something went wrong. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_SM_BANNER_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.data.message,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case CREATE_SM_BANNER_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_SM_BANNER_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.data.message,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case UPDATE_SM_BANNER_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_SM_BANNER_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.data.message,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case DELETE_SM_BANNER_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SEND_REQUEST_INFORMATION_EMAIL_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.data.message,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case SEND_REQUEST_INFORMATION_EMAIL_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UNHOLD_ORDERS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Selected orders were unheld successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case UNHOLD_ORDERS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case HOLD_ORDERS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Selected orders were put on hold successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case HOLD_ORDERS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_SUCCESS: {
      const {delivery_status} = action.orders[0].extension_attributes;
      const status = delivery_status === '1' ? 'posted' : 'unposted';
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Selected orders were ${status} successfully.`,
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }
    case UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case GENERATE_ORDERS_INVOICE_PDF_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `${error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_SUBSCRIPTION_SETUP_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Store setup prices saved successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_SUBSCRIPTION_SETUP_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SEND_REQUEST_PRODUCTS_EMAIL_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Request sent successfully',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SEND_REQUEST_PRODUCTS_EMAIL_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_STORE_EMAILS_CONFIGS_DATA_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Email configurations saved successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_STORE_EMAILS_CONFIGS_DATA_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_STORE_EMAILS_DATA_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Email configurations saved successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_STORE_EMAILS_DATA_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case GET_CUSTOMER_PUSH_CART_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_ACTIVE_CART_COMBINED_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_CUSTOMER_SUBSCRIPTION_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Subscription successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_CUSTOMER_SUBSCRIPTION_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Subscription successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Subscription successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_TERMS_AND_CONDITIONS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Can\'t delete current item.',
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_TERMS_AND_CONDITIONS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Successfully deleted.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_TERMS_AND_CONDITIONS_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case SAVE_TERMS_AND_CONDITIONS_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Successfully saved.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case BILL_CUSTOMER_SUBSCRIPTION_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case BILL_CUSTOMER_SUBSCRIPTION_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Subscription billed successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_DEAL_TASK_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Task was created successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_DEAL_TASK_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Task was updated successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_DEAL_TASK_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Task was deleted successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_DEAL_ACTIVITY_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Activity was created successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case UPDATE_DEAL_ACTIVITY_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Activity was updated successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_DEAL_ACTIVITY_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Activity was deleted successfully.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_DEAL_TASK_FAILED:
    case UPDATE_DEAL_TASK_FAILED:
    case DELETE_DEAL_TASK_FAILED:
    case CREATE_DEAL_ACTIVITY_FAILED:
    case UPDATE_DEAL_ACTIVITY_FAILED:
    case DELETE_DEAL_ACTIVITY_FAILED: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: action.error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_DEPOSIT_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Deposit successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_DEPOSIT_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }
    case EDIT_DEPOSIT_PAYMENT_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Deposit payment info successfully updated.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_DEPOSIT_PAYMENT_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_GIFT_CARD_CODE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Gift Code successfully created.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_GIFT_CARD_CODE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case rpaActions.SET_RPA_CHARGE_MAPPED_PRODUCT_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Charge successfully mapped.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case rpaActions.SET_RPA_CHARGE_MAPPED_PRODUCT_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Map is failed. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case rpaActions.UPDATE_RPA_CHARGE_MAPPED_PRODUCT_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Charge successfully edited.',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case rpaActions.UPDATE_RPA_CHARGE_MAPPED_PRODUCT_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: `Edit is failed. Error: ${error.response.data.error}`,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_MARKETING_SEGMENTS_CUSTOMER_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Successfully saved',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_MARKETING_SEGMENTS_CUSTOMER_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_AUTO_QUOTE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Successfully created',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case CREATE_AUTO_QUOTE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_AUTO_QUOTE_SCHEDULE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Successfully edited',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case EDIT_AUTO_QUOTE_SCHEDULE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_AUTO_QUOTE_SCHEDULE_SUCCESS: {
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: 'Successfully deleted',
        type: 'success',
        key: new Date().getTime()
      }];
      break;
    }

    case DELETE_AUTO_QUOTE_SCHEDULE_FAILED: {
      const {error} = action;
      state.notificationsStack = [...state.notificationsStack, {
        isOpen: true,
        message: error.response.data.error,
        type: 'error',
        key: new Date().getTime()
      }];
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
